import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

const ModalTambahAnggota = ({ isOpen, onClose, onSimpan, loading }) => {
  const [formData, setFormData] = useState({
    nis: '',
    nama_lengkap: '',
    nama_pengguna: '',
    kata_sandi: '',
    kelas: '',
    alamat: '',
    tahun_masuk: '',
    kode_anggota: ''
  });

  const [kodeLoading, setKodeLoading] = useState(false);
  const [kodeError, setKodeError] = useState(null);

  const fetchNextKodeAnggota = async () => {
    setKodeLoading(true);
    setKodeError(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota`);
      if (!response.ok) {
        throw new Error('Gagal mengambil data anggota untuk kode otomatis');
      }
      const data = await response.json();

      let nextKode = 'AP001';

      if (data.length > 0) {
        // Filter dan ambil hanya kode yang valid (AP diikuti angka)
        const validNumbers = data
          .filter(item => {
            const kode = item.kode_anggota || '';
            return /^AP\d+$/.test(kode); // Regex: AP diikuti minimal 1 digit
          })
          .map(item => parseInt(item.kode_anggota.substring(2)))
          .filter(num => !isNaN(num));

        if (validNumbers.length > 0) {
          const maxNumber = Math.max(...validNumbers);
          const nextNumber = maxNumber + 1;
          nextKode = `AP${String(nextNumber).padStart(3, '0')}`;
        }
      }

      console.log(`🔢 Next Kode Anggota: ${nextKode}`);
      setFormData(prevData => ({ ...prevData, kode_anggota: nextKode }));

    } catch (err) {
      console.error('❌ Error fetching kode anggota:', err);
      setKodeError(err.message);
    } finally {
      setKodeLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchNextKodeAnggota();
      const currentYear = new Date().getFullYear().toString();
      setFormData(prev => ({
        ...prev,
        tahun_masuk: currentYear,
        nis: '',
        nama_lengkap: '',
        nama_pengguna: '',
        kata_sandi: '',
        kelas: '',
        alamat: ''
      }));
    }
  }, [isOpen]);

  const handleKelasChange = (e) => {
    const kelasValue = e.target.value;
    const currentYear = new Date().getFullYear();
    let tahunMasuk = '';

    if (kelasValue.includes('7')) {
      tahunMasuk = currentYear.toString();
    } else if (kelasValue.includes('8')) {
      tahunMasuk = (currentYear - 1).toString();
    } else if (kelasValue.includes('9')) {
      tahunMasuk = (currentYear - 2).toString();
    } else if (kelasValue === 'Guru') {
      tahunMasuk = '';
    }

    setFormData({
      ...formData,
      kelas: kelasValue,
      tahun_masuk: tahunMasuk
    });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.nis || !formData.nama_lengkap || !formData.nama_pengguna ||
      !formData.kata_sandi || !formData.kelas || !formData.alamat) {
      Swal.fire({
        icon: 'warning',
        title: 'Peringatan',
        text: 'Semua field wajib diisi!'
      });
      return;
    }

    try {
      await onSimpan(formData);

      Swal.fire({
        icon: 'success',
        title: 'Berhasil',
        text: 'Anggota berhasil ditambahkan!'
      });

      setFormData({
        nis: '',
        nama_lengkap: '',
        nama_pengguna: '',
        kata_sandi: '',
        kelas: '',
        alamat: '',
        tahun_masuk: '',
        kode_anggota: ''
      });
      onClose();

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Gagal',
        text: error.message || 'Terjadi kesalahan saat menambahkan anggota.'
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={onClose}></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Tambah Anggota</p>
          <button className="delete" aria-label="close" onClick={onClose}></button>
        </header>
        <section className="modal-card-body">
          <div className="field">
            <label className="label">Kode Anggota <span className="has-text-danger">* Otomatis Terisi</span></label>
            <div className="control">
              {kodeLoading ? (
                <p>Memuat kode...</p>
              ) : kodeError ? (
                <p className="has-text-danger">Error: {kodeError}</p>
              ) : (
                <input className="input" type="text" value={formData.kode_anggota} readOnly />
              )}
            </div>
          </div>

          <div className="field">
            <label className="label">Nomor Induk Siswa <span className="has-text-danger">* Wajib diisi</span></label>
            <div className="control">
              <input
                className="input"
                type="text"
                name="nis"
                value={formData.nis}
                onChange={handleChange}
                placeholder="Masukan NIS"
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Nama Lengkap <span className="has-text-danger">* Wajib diisi</span></label>
            <div className="control">
              <input
                className="input"
                type="text"
                name="nama_lengkap"
                value={formData.nama_lengkap}
                onChange={handleChange}
                placeholder="Masukan Nama Lengkap"
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Nama Pengguna <span className="has-text-danger">* Wajib diisi</span></label>
            <div className="control">
              <input
                className="input"
                type="text"
                name="nama_pengguna"
                value={formData.nama_pengguna}
                onChange={handleChange}
                placeholder="Masukan Nama Pengguna"
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Kata Sandi <span className="has-text-danger">* Wajib diisi</span></label>
            <div className="control">
              <input
                className="input"
                type="password"
                name="kata_sandi"
                value={formData.kata_sandi}
                onChange={handleChange}
                placeholder="Masukan Kata Sandi"
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Kelas <span className="has-text-danger">* Wajib diisi</span></label>
            <div className="control">
              <div className="select is-fullwidth">
                <select name="kelas" value={formData.kelas} onChange={handleKelasChange}>
                  <option value="">-- Harap Pilih Kelas --</option>
                  <option value="Guru">Guru</option>
                  <option value="Kelas 7A">Kelas 7A</option>
                  <option value="Kelas 7B">Kelas 7B</option>
                  <option value="Kelas 8A">Kelas 8A</option>
                  <option value="Kelas 8B">Kelas 8B</option>
                  <option value="Kelas 9A">Kelas 9A</option>
                  <option value="Kelas 9B">Kelas 9B</option>
                </select>
              </div>
            </div>
          </div>

          {formData.kelas !== 'Guru' && formData.kelas && (
            <div className="field">
              <label className="label">Tahun Masuk <span className="has-text-info">* Otomatis terisi</span></label>
              <div className="control">
                <input
                  className="input"
                  type="text"
                  name="tahun_masuk"
                  value={formData.tahun_masuk}
                  onChange={handleChange}
                  placeholder="Tahun masuk siswa"
                />
              </div>
              <p className="help">Tahun lulus otomatis: {formData.tahun_masuk ? parseInt(formData.tahun_masuk) + 3 : '-'}</p>
            </div>
          )}

          <div className="field">
            <label className="label">Alamat <span className="has-text-danger">* Wajib diisi</span></label>
            <div className="control">
              <textarea
                className="textarea"
                name="alamat"
                value={formData.alamat}
                onChange={handleChange}
                placeholder="Masukan Alamat"
              />
            </div>
          </div>

          <div className="field">
            <div className="control">
              <button
                onClick={handleSubmit}
                className={`button is-info is-fullwidth ${loading ? 'is-loading' : ''}`}
                disabled={loading}
              >
                Simpan
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ModalTambahAnggota;